import AdminPage from "../components/AdminPage";
import HomePage from "../components/HomePage";
import ViewHintPage from "../components/ViewHintPage";
import DiscoveryPage from "../components/DiscoveryPage";
import RafflePage from "../components/RafflePage";

const ROUTES = [
    {
        path: "/",
        element: <HomePage />,
    },
    {
        path: "/hint/:id",
        element: <ViewHintPage />,
    },
    {
        path: "/admin",
        element: <AdminPage />,
    },
    {
        path: "/discover/:token",
        element: <DiscoveryPage />,
    },
    {
        path: "/discover",
        element: <HomePage />,
    },
    {
        path: "/raffle",
        element: <RafflePage />,
    },
];

export default ROUTES;
